import { ReactNode } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import Menu from "./Menu";

interface AppShellProps {
  isMenuCollapsed: boolean;
  onToggleMenu: () => void;
  children: ReactNode;
}

const AppShell = ({
  isMenuCollapsed,
  onToggleMenu,
  children,
}: AppShellProps) => {
  return (
    <main className="relative isolate min-h-dvh text-white">
      <div className="pointer-events-none fixed inset-0 z-0 bg-app" />
      <div className="pointer-events-none fixed inset-0 z-0 bg-[radial-gradient(circle_at_top,rgba(244,114,182,0.18),transparent_28%),radial-gradient(circle_at_90%_10%,rgba(236,72,153,0.14),transparent_18%)]" />

      <aside
        className={`fixed left-0 top-0 z-30 flex h-full flex-col border-r border-white/10 bg-black/45 backdrop-blur-xl transition-all duration-300 ${
          isMenuCollapsed ? "w-16" : "w-64"
        }`}
      >
        <button
          className="flex h-14 w-full items-center px-5 text-sm text-zinc-300 transition hover:text-white"
          onClick={onToggleMenu}
          type="button"
        >
          {isMenuCollapsed ? <FaChevronRight /> : <FaChevronLeft />}
        </button>
        <div className="min-h-0 flex-1">
          <Menu isCollapsed={isMenuCollapsed} />
        </div>
      </aside>

      <section
        className={`relative z-10 box-border min-h-dvh px-4 py-4 transition-all duration-300 sm:px-6 sm:py-6 ${
          isMenuCollapsed
            ? "ml-16 w-[calc(100%-4rem)]"
            : "ml-64 w-[calc(100%-16rem)]"
        }`}
      >
        <div className="mx-auto flex w-full max-w-7xl flex-col gap-6">
          {children}
        </div>
      </section>
    </main>
  );
};

export default AppShell;
